import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import TextList from '../../EsimQrCodeBlock/Partials/TextList/TextList';
import {connect} from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {setCurrentStep, setCurrentPopUp} from '../TransferOrganizationAccountSlice';
import {TransferAccountStep, PopupEnum} from '../Constant/Constant';

const EsimInstruction = (props) => {
  return (
    <div className='esimInstructionMain stepContainer'>
      <div className='L_Title'>
        {' '}
        דוגמא להוראות הפעלת <br />
        ה-esim{' '}
      </div>
      <div className='M_Title'> לפניך הפעולות שעל המנוי לבצע כדי להפעיל את ה-eSIM במכשיר שלו</div>

      <div className='section'>
        <div className='S_Title bold'> אז מה צריך לעשות?</div>
        {props.esimInstructionList && <TextList textList={props.esimInstructionList} purpleIcon={true} />}
        <div className='EsimInfo'>
          <Image src={require('../icons/light.svg')} />
          <span> יש כבר eSIM מותקן על המכשיר? </span>
          <Image src={require('../icons/info.svg')}
            onClick={() => {
              props.setCurrentPopUp(PopupEnum.DeleteEsimInstruction);
            }} />
        </div>
      </div>

      <div className='section QRCode'>
        <div className='S_Title bold'> הפעלה עם קוד QR</div>
        <div className='M_Title'> על המנוי לסרוק את הקוד שמופיע בהוראות ההפעלה באמצעות המכשיר עליו יופעל הקו</div>
        <Image src={require('../icons/qrCodeExample.svg')} />
        <span>*דוגמא בלבד*</span>
      </div>

      <div className='section'>
        <div className='S_Title bold'>
          אין באפשרות המנוי לסרוק? <br />
          ניתן להפעיל את ה-eSIM עם קודי הפעלה
        </div>
        <div className='S_Title'>
          אם אין אפשרות לפתוח את המייל במכשיר אחר או במחשב אפשר להפעיל את ה-eSIM באמצעות הזנה ידנית של קודי ההפעלה SMDP ו-AccessCode
        </div>
        <div className='qr_code_purple_info S_Title'>
          <p>
            <span className='bold'>SMDP:</span>
            <span>thales1-livelab/prod ondemandconnectivity.com</span>
          </p>
          <p>
            <span className='bold'>AccessCode:</span>
            <span>T34UG0JC6LA6J9VT</span>
          </p>
        </div>
        <span> *דוגמא בלבד*</span>
        <BtnSubmit
          text={'הבנתי תודה'}
          onclick={() => {
            props.setCurrentStep(TransferAccountStep.EsimSuccessPage);
          }}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  esimInstructionList: state.TransferOrganizationAccount.epiData.instructionsPageTextList.value,
});

const mapDispatchToProps = {setCurrentStep, setCurrentPopUp};

export default connect(mapStateToProps, mapDispatchToProps)(EsimInstruction);
